// extracted by mini-css-extract-plugin
export default {"landingLayout":"LandingLayout_landingLayout__d-ZGE"};